import Vue from 'vue';
import Vuex from 'vuex';
import $ from 'jquery';
import { Globals } from './globals.js';
Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        // User
        user_info: null,
        is_logged_in: false,
        // Catalog
        catalog_opened: false,
        selected_catalog: {
            all: false, // if true, qs = ''
            items: [],  // tree-model of selects
            selected_ids: [], // all selected ids
        },
        // Order
        order_default: {
            id: null,
            total: 0,
            commentary: '',
        },
        order_info: {
            id: null,
            total: 0,
            commentary: '',
        },
        order_goods_info: [],
    },
    getters: {
        // User
        user_info_get: state => state.user_info,
        logged_state: state => state.is_logged_in,
        // Catalog
        catalog_opened_get: state => state.catalog_opened,
        selected_catalogs: state => state.selected_catalog,
        selected_catalogs_qs: state => state.selected_catalog.selected_ids.toString(),
        // Order
        order_info_get: state => state.order_info,
        order_goods_get: state => state.order_goods_info,
        order_total_qty_get: state => {
            var total_qty = 0;
            state.order_goods_info.forEach(function(item) {
                total_qty += item.quantity;
            });
            return total_qty;
        },
        order_goods_list_get: state => {
            var items_list = [];
            state.order_goods_info.forEach(function(item) {
                items_list.push(item.item.id);
            });
            return items_list;
        },
    },
    // user_info_set, logged_state_set, selected_catalog_set, order_info_set, order_goods_set
    actions: {
        // Sets the user-data if received in local component function
        user_info_set(context, user_data) {
            context.commit('user_info_set', user_data)
        },
        // Sets logged state and updates user info on the way
        logged_state_init(context, api_check) {
            // Read user token
            const token = sessionStorage.getItem('auth_token');
            if (!token) {
                context.commit('logged_in_set', false);
                context.commit('user_info_set', null);
                return;
            }
            // Validate current user token
            if (api_check) {
                $.ajaxSetup({
                    headers: {'Authorization': 'Token ' + token},
                });
                $.ajax({
                    url: '' + Globals.API.ROOT + Globals.API.MAIN + 'profiles/',
                    type: 'GET',
                    success: (response) => {
                        if (response.length > 0) {
                            context.commit('logged_in_set', true);
                            context.commit('user_info_set', response[0]);
                        } else {
                            context.commit('logged_in_set', false);
                            context.commit('user_info_set', null);
                        }
                    },
                    error: () => {
                        context.commit('logged_in_set', false);
                        context.commit('user_info_set', null);
                    }
                })
            } else {
                context.commit('logged_in_set', true)
            }
        },
        // Catalog
        catalog_toggle(context) {
            context.commit('toggle_catalog_view', !context.state.catalog_opened)
        },
        catalog_open(context) {
            context.commit('toggle_catalog_view', true)
        },
        catalog_close(context) {
            context.commit('toggle_catalog_view', false)
        },
        selected_catalog_set(context, catalog) {
            context.commit('selected_catalog_set', catalog)
        },
        // Order
        order_info_init(context) {
            // Read user token
            const token = sessionStorage.getItem('auth_token');
            if (!token) {
                context.commit('logged_in_set', false);
                context.commit('user_info_set', null);
                return;
            }
            $.ajaxSetup({
                headers: {'Authorization': 'Token ' + token},
            });
            // Load active order
            $.ajax({
                url: '' + Globals.API.ROOT + Globals.API.MAIN + 'order/orders/',
                type: 'GET',
                data: {
                    status: 0
                },
                success: (response) => {
                    if (response.length > 0) {
                        context.commit('order_info_set', response[0]);
                    } else {
                        context.commit('order_info_set', context.state.order_default);
                    }
                },
                error: () => {
                    context.commit('order_info_set', context.state.order_default);
                },
                complete: () => {
                    context.dispatch('order_goods_init')
                }
            })
        },
        order_goods_init(context) {
            // Read user token
            const token = sessionStorage.getItem('auth_token');
            if (!token) {
                context.commit('logged_in_set', false);
                context.commit('user_info_set', null);
                return;
            }
            $.ajaxSetup({
                headers: {'Authorization': 'Token ' + token},
            });
            // Get order id
            if (!context.state.order_info.id) {
                // No order, return []
                context.commit('order_goods_set', []);
                return;
            }
            // Load active order goods
            $.ajax({
                url: '' + Globals.API.ROOT + Globals.API.MAIN + 'order/items/',
                type: 'GET',
                data: {
                    order_id: context.state.order_info.id,
                    status: 0
                },
                success: (response) => {
                    context.commit('order_goods_set', response);
                },
                error: () => {
                    context.commit('order_goods_set', []);
                },
            })
        },
    },
    mutations: {
        user_info_set(state, payload){
            state.user_info = payload;
        },
        logged_in_set(state, payload){
            state.is_logged_in = payload;
        },
        toggle_catalog_view(state, payload){
            state.catalog_opened = payload;
        },
        selected_catalog_set(state, payload){
            state.selected_catalog = payload;
        },
        order_info_set(state, payload){
            state.order_info = payload;
        },
        order_goods_set(state, payload){
            state.order_goods_info = payload;
        },
    },
})